import api from 'shared/api'

export const loadArticles = async ({ accessToken, type }) => {
  const published = type === 'published'

  if (published) {
    const {
      data: list,
      headers: { 'x-total-results': total },
    } = await api.get(`/articles`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    })

    return { list, total }
  }
  const {
    data: list,
    headers: { 'x-total-results': total },
  } = await api.get(`/drafts`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  })

  return { list, total }
}

export const deleteDraft = async ({ accessToken, id }) => {
  await api.delete(`/drafts/${id}`, {
    headers: { Authorization: `Bearer ${accessToken}` },
  })
}

export const deleteArticle = async ({ accessToken, id }) => {
  await api.delete(`/articles/${id}`, {
    headers: { Authorization: `Bearer ${accessToken}` },
  })
}

export const loadFollowing = async ({ username, page }) => {
  const follows = [
    api.get(`/public/profile/${username}/following`, {
      params: {
        page,
        limit: 100,
      },
    }),
    api.get(`/public/profile/${username}/following-tags`, {
      params: {
        page,
        limit: 100,
      },
    }),
  ]
  const [
    {
      data: writerList,
      headers: { 'x-total-results': writerTotal },
    },
    {
      data: topicList,
      headers: { 'x-total-results': topicTotal },
    },
  ] = await Promise.all(follows)

  return {
    writerState: {
      list: writerList,
      total: writerTotal,
    },
    topicState: {
      list: topicList,
      total: topicTotal,
    },
  }
}

export const loadFollowers = async ({ username, page }) => {
  const {
    data: list,
    headers: { 'x-total-results': total },
  } = await api.get(`/public/profile/${username}/followers`, {
    params: {
      page,
      limit: 100,
    },
  })

  return { list, total }
}

export const followUser = async ({ accessToken, username }) => {
  await api.post(`/users/follow/${username}`, null, {
    headers: { Authorization: `Bearer ${accessToken}` },
  })
}

export const unfollowUser = async ({ accessToken, username }) => {
  await api.delete(`/users/follow/${username}`, {
    headers: { Authorization: `Bearer ${accessToken}` },
  })
}

export const followTopic = async ({ accessToken, slug }) => {
  await api.post(`/users/follow-tag/${slug}`, null, {
    headers: { Authorization: `Bearer ${accessToken}` },
  })
}

export const unfollowTopic = async ({ accessToken, slug }) => {
  await api.delete(`/users/follow-tag/${slug}`, {
    headers: { Authorization: `Bearer ${accessToken}` },
  })
}

export const loadPosts = async ({ username, page, accessToken }) => {
  const {
    data: list,
    headers: { 'x-total-results': total },
  } = await api.get(`/public/profile/${username}/posts?page=${page}&limit=20`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  })

  return { list, total }
}
